import React, { useContext, useEffect, useRef, useState } from "react";
import "../SafeAggrement/SafeAggrement.scss";
import "../PPMContent/PPMContent.scss";
import "./CorporateGovernancePolicy.scss";
import parser from "html-react-parser";
import { useNavigate } from "react-router-dom";
import { Context } from "../../contextApi/contextProvider";
import { cmsPrivateContent } from "../../utils/cmscontent/cms";
import { MarkDocumentRead } from "../../utils/Api/api";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";

const AntiFraudPolicy = () => {
  const navigator = useNavigate();
  const loaction = useGeoLocation();
  const { userLoginData, setAccessDoc, setUserLoginData, accessDoc } =
    useContext(Context);

  const [htmlStr, setHtmlStr] = useState<any>([]);


  
  const contents = [
    "1. Introduction ",
    "2. Scope ",
    "3. Definitions ",
    "4. Objective of the Policy ",
    "5. Responsibilities ",
    "6. Actions Considered as Fraud ",
    "7. Reporting Procedures ",
    "8. Investigation Procedures ",
    "9. Disciplinary Actions ",
    "10. Review and Monitoring ",
  ];
  const token = JSON.parse(localStorage.getItem("access_token") as string);

  const fetchCmsContent = async () => {
    const response = await cmsPrivateContent({
      post_id: "9650",
      lat: loaction.coordinates.lat,
      log: loaction.coordinates.lng,
    });
    setHtmlStr(response);
  };
  useEffect(() => {
    if (userLoginData.status == 200) {
      readDoc();
      fetchCmsContent();
    }
    if (userLoginData.status == 404) {
      navigator("/");
    }
  
    if (token === "" || token === null || token === undefined) {
      navigator("/");   }
    document.title = "TICCA | Antifraud Policy";
    window.scrollTo(0, 0);
  }, [userLoginData.status]);

  const readDoc = async () => {
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "9650",
      });
    } catch (error) {}
  };

  return (
    <>
       {htmlStr.length &&  <div className="watermaring-main-dev">
        <img
          src="https://public.ticca.com/images/svg/Watermark_Business_Summary.svg"
          alt="logo"
        />
        <p>
          Commercial in Confidence <br />
          Content under NDA.
          <br /> {userLoginData?.email}
        </p>
      </div> }
      {htmlStr.length <= 2 && (
        <div
          style={{ marginTop: "100px" }}
          className=" page-shimmer-container-co"
        >
          {Array.from({ length: 10 }).map((_, index) => (
            <div className="page-shimmer-co" key={index}></div>
          ))}
        </div>
      )}
      {htmlStr.length > 2 && (
        <div style={{ marginTop: "100px" }} className="shareholder-main-dev">
          <div className="safe-agreement-container">
            {/* Header */}
            <div className="header">
              <p className="cor-title">Antifraud Policy</p>
            </div>

            {/* Table of Contents */}
            <div className="table-of-contents">
              <h2>TABLE OF CONTENTS</h2>
              <ul>
                {contents.map((item, index) => (
                  <li key={index}>
                    <div className="line">
                      <span className="title">{item}</span>
                      <span className="dots"></span>
                      <span className="page-number">{3 + index}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="safe-agreement-container">
            {htmlStr.length > 1 &&
              htmlStr?.map((elem: any, index: number) => (
                <div
                  key={`table-of-contentsr-${index}`}
                  className="safe-agreement-cms-container"
                >
                  {parser(elem)}
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

// 🧠 Prevent re-renders unless props actually change
export default AntiFraudPolicy;
